import {
  Flex,
  Image,
  Heading,
  Text,
  Box,
  Button,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import Section from "./Section";
import Header from "./Header";
import Footer from "./Footer";
import { MAIN, MAIN_BACKGROUND, SECONDARY } from "./colours";
import { getFeaturedEvent } from "./events/eventConfig";

export default function Home() {
  const featured = getFeaturedEvent();

  return (
    <>
      <Header />
      <Section
        title="LOCALLY SOURCED, SUSTAINABLE AND SEASONAL CATERING"
        body="Made by Harri & Meg. North Wales based."
      >
        <Flex direction={{ base: "column", sm: "row" }} align="stretch" gap="4" mt="8">
          <Button
            as={RouterLink}
            to={`/${featured.slug}`}
            size="lg"
            bg={MAIN}
            color={MAIN_BACKGROUND}
            border={`2px solid ${MAIN}`}
            borderRadius={"none"}
            whiteSpace="normal"
            height="auto"
            minH="12"
            py="3"
            px="6"
            textAlign="center"
            _hover={{ bg: "transparent", color: MAIN }}
          >
            Book {featured.title}
          </Button>
          <Button
            size="lg"
            bg="transparent"
            color={MAIN}
            border={`2px solid ${MAIN}`}
            borderRadius={"none"}
            height="auto"
            minH="12"
            py="3"
            px="6"
            _hover={{ bg: MAIN, color: MAIN_BACKGROUND }}
            onClick={() =>
              document
                .getElementById("GET IN TOUCH")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Contact us
          </Button>
        </Flex>
      </Section>

      <Section
        title="FOR HOLIDAYS"
        secondary
        body="Step away from your kitchen during your holiday – let us handle
                the cooking. Enjoy custom home-cooked meals just the way you
                like them. Whether you fancy dishes ready to pop in the oven or
                want us to handle everything from start to finish, so that you
                can spend a bit more time in the mountains or on the beach."
      />

      <Flex>
        <Box w={{ base: "100%", lg: "50%" }} bg={MAIN_BACKGROUND}>
          <Image src="/mountain.jpeg" alt="logo" p="0" m="0" />
        </Box>

        <Box
          display={{ base: "none", lg: "block" }}
          w="50%"
          bg={MAIN_BACKGROUND}
        >
          <Image src="/table.jpeg" alt="logo" p="0" m="0" />
        </Box>
      </Flex>

      <Section title="FOR WEDDINGS">
        <Flex flexDir={"column"} color={MAIN}>
          <Text fontSize={"lg"} mb="6">
            We cater weddings of all shapes and sizes, from intimate dinners to full weekend celebrations.
          </Text>
          <Text fontSize={"lg"} mb="6">
            Whether it's a marquee by the sea, a barn in the hills or a more traditional venue, we design food that suits the setting and the day. Menus are shaped by the season, your guest list and how you want the celebration to feel, from relaxed sharing feasts to more classic wedding breakfasts.
          </Text>
          <Text fontSize={"lg"} mb="8">
            Everything we do is well organised, flexible and centred around great food.
          </Text>
        </Flex>
      </Section>
      <Section
        title="FOR RETREATS"
        secondary
        body="We love cooking for retreats. Creating calm, welcoming spaces and serving nourishing, balanced food is a big part of what we do. Our menus are designed to support energy, connection and time spent outdoors. If you're planning a retreat, or would like to host one together, get in touch."
      />

      <Section
        title="FOR SECRET DINNERS"
        body="For you and your loved one. We'll throw you a secret dinner outdoors. We'll check the forecast and choose the best location to set up a romantic dinner for two."
      />

      <Flex>
        <Box w={{ base: "100%", lg: "50%" }} bg={MAIN_BACKGROUND}>
          <Image src="/me.jpeg" alt="logo" p="0" m="0" />
        </Box>

        <Box
          display={{ base: "none", lg: "block" }}
          w="50%"
          bg={MAIN_BACKGROUND}
        >
          <Image src="/steak.jpeg" alt="logo" p="0" m="0" />
        </Box>
      </Flex>

      <Section
        title="GET IN TOUCH"
        body="Drop us a line to discuss menus, retreat ideas, special occasions or
            joining forces!"
      >
        <Text pb="4" color={MAIN}>
          Email us at{" "}
          <a href="mailto:happyfigfoods@gmail.com">
            <strong>happyfigfoods@gmail.com</strong>
          </a>
        </Text>
      </Section>
      <Section title="WHAT PEOPLE ARE SAYING" secondary>
        <Flex flexDir={"column"} color={SECONDARY} my="12">
          <Heading pb="4" size={"lg"}>
            "We absolutely loved having Happy Fig for our wedding catering — we couldn't rate them highly enough! They fitted perfectly with our relaxed DIY wedding at Uchaf Farm and truly made the day feel complete."
          </Heading>
          <Text>- Frances</Text>
        </Flex>

        <Flex flexDir={"column"} color={SECONDARY} mt="12">
          <Heading pb="4" size={"lg"}>
            "Harri & Meg from Happy Fig produced the most delicious Sunday lunch with all the trimmings for a birthday celebration for 22 guests. They provided a selection of delectable canapés served on carved wooden platters."
          </Heading>
          <Text>- Philip Pariser</Text>
        </Flex>

        <Flex flexDir={"column"} color={SECONDARY} mt="12">
          <Heading pb="4" size={"lg"}>
            "Meg cooked up an absolute feast for such a lovely and special occasion. The food was utterly delicious and she and Sam were a delight to have in our home. Thank you for making our evening so easy & memorable. We can't wait to have another excuse to get you guys back."
          </Heading>
          <Text>- Joey Matveieff</Text>
        </Flex>

        <Flex flexDir={"column"} color={SECONDARY} mt="12">
          <Heading pb="4" size={"lg"}>
            "Harri and Meg were lovely, kind, accommodating and helpful. Their food was incredibly delicious and beautifully served for our family celebratory meal. They were great fun and arrived punctually, set up and cleared everything up."
          </Heading>
          <Text>- Rae Renwick</Text>
        </Flex>

        <Flex flexDir={"column"} color={SECONDARY} mt="12">
          <Heading pb="4" size={"lg"}>
            "Happy Fig came and cooked us a gorgeous Autumn roast for my 40th birthday celebrations. Harri and Meg were absolutely superb from start to finish. They provided a range of delicious and creative options for the meal and were so helpful."
          </Heading>
          <Text>- Suzanna Jackson</Text>
        </Flex>

        <Button
          mt="12"
          size="lg"
          bg={SECONDARY}
          color={MAIN_BACKGROUND}
          border={`2px solid ${SECONDARY}`}
          borderRadius={"none"}
          _hover={{ bg: "transparent", color: SECONDARY }}
          onClick={() => window.open("https://share.google/ZFETwSuwbzCJjWn62")}
        >
          Check out our Google reviews
        </Button>
      </Section>
      <Footer />
    </>
  );
}
